export const nextPageParam = (lastPage: any): number | undefined => {
  const { currentPage, data } = lastPage || {};
  if (currentPage < data?.totalPages) {
    return currentPage + 1;
  }
  return undefined;
};